var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('post-landing',{attrs:{"slug":"contact-us","no-button":"","fill-height":""}}),_c('call-to-action')],1)}
var staticRenderFns = []

export { render, staticRenderFns }